import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'
import { useDispatch } from 'react-redux'

import { patientApi } from '@/core/api/patient'
import { useRequestHandler } from '@/hooks/useRequestHandler'
import { createPatientAccount, selectPatientUpdateRequestTracker } from '@/redux/reducers/patient.reducer'

export function useCreatePatientAccount(patientId: string, onCompleted?: () => void) {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  const createPatientAccountRequestHandler = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t`The patient account has been successfully created. The patient should have received their password by email`, { variant: 'success' })
      dispatch(patientApi.endpoints.getPatient.initiate(patientId, { forceRefetch: true }))
      onCompleted?.()
    },
    onError: () => {
      enqueueSnackbar(t`An error occurred during the creation of the patient account. Have you specified an email?`, { variant: 'error' })
    },
    requestTrackerSelector: selectPatientUpdateRequestTracker,
  })

  return useCallback(() => {
    createPatientAccountRequestHandler.dispatch(createPatientAccount(patientId))
  }, [createPatientAccountRequestHandler.dispatch, patientId])
}
